import {
    COMPARTMENTLIST_REQUEST,
    COMPARTMENTLIST_ERROR,
    COMPARTMENTLIST_SUCCESS,
    COMPARTMENTLIST_params
} from "../actions/compartmentList";
import apiCalls from "utils/api";
import store from '../../store';
import Vue from "vue";

const state = {
    compartmentList: [],
    compartmentListStatus: "",
};

const getters = {
    getCompartmentList: state => state.compartmentList,
    isCompartmentListLoaded: state => !!state.compartmentList,
    getCompartmentListStatus: state => state.compartmentListStatus,
    getCompartmentListTotalQuantity: state => state.compartmentList.reduce((result, el) => { return result + el.QuantityComp }, 0),
    getCompartmentListTotalWeight: state => state.compartmentList.reduce((result, el) => { return result + el.TotalWeightComp }, 0),
};

const actions = {
    [COMPARTMENTLIST_REQUEST]: ({ commit, dispatch }) => {
        commit(COMPARTMENTLIST_REQUEST);
        var tripLineId = null;

        if (store.state.ordersList.ordersList.length > 0)
            tripLineId = store.state.ordersList.ordersList[0].TripLineId;

        var filter = [
            {
                Filters: [
                    {
                        name: 'TripLineId',
                        value: tripLineId,
                        operator: '='
                    }
                ]
            }
        ];

        COMPARTMENTLIST_params.filter = JSON.stringify(filter);

        apiCalls.apiCall({ url: "get", method: "GET", params: COMPARTMENTLIST_params })
            .then(resp => {
                commit(COMPARTMENTLIST_SUCCESS, resp.data);            
            })
            .catch(() => {
                commit(COMPARTMENTLIST_ERROR);
            });
    }
};

const mutations = {
    [COMPARTMENTLIST_REQUEST]: state => {
        state.compartmentListStatus = "loading";
    },
    [COMPARTMENTLIST_SUCCESS] : (state, resp) => {
        state.compartmentListStatus = "success";
        state.compartmentList = resp.data;
        Vue.set(state, "compartmentList", resp.data);
    },
    [COMPARTMENTLIST_ERROR]: state => {
        state.compartmentListStatus = "error";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};